<template>
    <SKModal
        ref="modal"
        actionButtonsPosition="right"
        :hasAcceptButton="true"
        :acceptCallback="create"
        :accept-button-disabled="!saveEnabled"
        :title="modalTitle"
    >
        <template v-slot:body>
            <div class="flex flex-row gap-4 items-center">
                <button class="sk-btn sk-btn-primary rounded-lg btn-border" @click="openFileInput">
                    {{ $t('admin.apps.status.certificate.upload_certificate')}}
                </button>
                <p class="mb-0" v-if="file">{{ file.name }}</p>
                <p class="mb-0 text-danger" v-if="!isValidFile">Invalid file</p>
            </div>

            <vs-input
                ref="input-file"
                type="file"
                hidden
                :name="name"
                id="certificate"
                @change="onFileChange"
            />

            <vs-input v-if="platform === 'ios'"
                      class="mt-8 border-grey-light w-full"
                      type="text"
                      v-model="signingKeyId"
                      :label="$t('admin.apps.status.certificate.signing_key_id')"
                      required
            />
        </template>
    </SKModal>
</template>
<script>

import LabelForm from '@/modules/Shared/Components/form/LabelForm'
import SKModal from "@/modules/Shared/Components/modal/SKModal";
import loader from "@/modules/Shared/Mixins/loader";
import AssetsService from "@/modules/Shared/Services/AssetsService";
import ApplicationService from "@/modules/Admin/Services/ApplicationService";
import { androidCertificateValidation, iosCertificateValidation } from '@/modules/Shared/Helpers/validationHelper';

export default {
    name: 'ModalUploadPlatformPushCertificate',
    mixins: [loader],
    props: {
        platform: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            file: null,
            filename: null,
            signingKeyId: null,
            isValidFile: true,
        }
    },
    components: {
        LabelForm,
        SKModal,
    },
    methods: {
        open() {
            this.initialize()
            this.$refs['modal'].open()
        },
        initialize() {
            this.file = null
            this.filename = null
            this.signingKeyId = null
        },
        openFileInput() {
            this.$refs['input-file'].$refs.vsinput.click()
        },
        async handleUploadCertificate(file) {
            const binaryAsset = new Blob([file]);
            const name = `${Date.now()}__${file.name}`

            let presignedUrl = await AssetsService.getTempAssetResource(name)
            presignedUrl = presignedUrl.url

            await AssetsService.uploadFileInS3Resource(presignedUrl, binaryAsset)

            return name
        },
        async onFileChange(event) {
            const file = event.target.files[0]
            this.isValidFile = await this.fileValidation(file)

            this.file = this.isValidFile ? file : null
        },
        async fileValidation(file) {
            try {
                const binaryAsset = new Blob([file]);
                const text = await binaryAsset.text();

                return this.platform === 'android'
                    ? androidCertificateValidation(text)
                    : iosCertificateValidation(text)
            } catch {
                return false
            }
        },
        async create() {
            await this.loadAndNotify(async () => {
                const filename = await this.handleUploadCertificate(this.file)
                const payload = this.platform === 'android'
                    ? {
                        android: {
                            filename: filename
                        },
                        ios: null
                    }
                    : {
                        android: null,
                        ios: {
                            filename: filename,
                            signing_key_id: this.signingKeyId
                        }
                    }
                await ApplicationService.editApplicationSnsPlatforms(this.$route.params.uuid, payload)
                this.$emit('created')
            })
        }
    },
    computed: {
        modalTitle() {
            return this.$t('admin.apps.status.certificate.title') +  ' ' + (this.platform === 'ios' ? 'iOS' : 'Android')
        },
        saveEnabled() {
            return (this.platform === 'android' && this.file) || (this.platform === 'ios' && this.file && this.signingKeyId)
        }
    }
}
</script>
